import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import all pages
import Home from './pages/Home';
import UniversalLogin from './pages/UniversalLogin'; // ✅ CHANGED
import StudentDetails from './pages/StudentDetails';
import Tables from './pages/Tables';
import StdDetails from './pages/StdDetails';
import FacultyDashboard from './pages/FacultyDashboard';

// Import all components
import FacultySignUp from './components/FacultySignUp';
import StudentDashboard from './components/StudentDashboard';
import StudentViewLogin from './components/StudentViewLogin';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<UniversalLogin />} /> {/* ✅ CHANGED */}
        <Route path="/student-registration" element={<StudentDetails />} />
        <Route path="/faculty-signup" element={<FacultySignUp />} />
        <Route path="/student-view-login" element={<StudentViewLogin />} />
        <Route path="/tables" element={<Tables />} />
        <Route path="/student-dashboard" element={<StudentDashboard />} />
        <Route path="/std-details" element={<StdDetails />} />
        <Route path="/faculty-dashboard" element={<FacultyDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

// 404 Page Component
const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>404 - Page Not Found</h1>
      <p style={styles.text}>The page you're looking for doesn't exist.</p>
      <a href="/" style={styles.link}>Go Home</a>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
  },
  title: {
    fontSize: '3rem',
    marginBottom: '1rem',
  },
  text: {
    fontSize: '1.2rem',
    marginBottom: '2rem',
  },
  link: {
    padding: '1rem 2rem',
    background: 'white',
    color: '#667eea',
    textDecoration: 'none',
    borderRadius: '10px',
    fontWeight: '600',
  },
};

export default App;
